import Box from '@amzn/meridian/box';
import styled from '@emotion/styled';
import { color } from '../../theme/colors';

const GreyBox = styled(Box)`
    box-shadow: 0px 0px 3px ${color.gray[300]};
`;

export { GreyBox };
